module.exports = __webpack_public_path__ + "media/images/ui__arrowRight--dark-7edbd5fa882b355b3955964430f5c84b.png";